__turbopack_context__.v({
  "links": "links-module-scss-module___r--BW__links",
  "links-desktop": "links-module-scss-module___r--BW__links-desktop",
  "links-mobile": "links-module-scss-module___r--BW__links-mobile",
});
